import type { RfpFormData } from '@/features/RfpForm/types/RfpFormData'
import { ref, watchEffect } from 'vue'
/**
 * @function useScrollToElement
 * @param classEl : string
 * Scroll To Class element
 */
export function useScrollToElement(classEl: string) {
  const els = document.querySelector(classEl)
  const header = document.querySelector('.js-header-height')
  if (els) {
    const el = els.getBoundingClientRect()
    const headerHeight = header ? header.getBoundingClientRect().height : 70
    const calcTop = el.top + document.documentElement.scrollTop - (headerHeight + 20)

    window.scrollTo({
      left: 0,
      top: calcTop,
      behavior: 'smooth',
    })
  }
}

/**
 * @function useDebugUpdateData
 * @param formData : RfpFormData
 * @return debugReplace: function, debugVersionData: string, debugWatcher: function
 * Assign debugData to formData and add formData to debugData
 */
export function useDebugUpdateData(formData: RfpFormData) {
  const debugVersionData = ref('')
  debugVersionData.value = JSON.stringify(formData)

  /** on click on replace data */
  function debugReplace() {
    const parseData: Partial<RfpFormData> = JSON.parse(debugVersionData.value)
    try {
      if (parseData.startDate) {
        parseData.startDate = new Date(parseData.startDate)
      }

      if (parseData.alternativeDate1) {
        parseData.alternativeDate1 = new Date(parseData.alternativeDate1)
      }

      if (parseData.alternativeDate2) {
        parseData.alternativeDate2 = new Date(parseData.alternativeDate2)
      }

      if (parseData.guestRoomsCheckIn) {
        parseData.guestRoomsCheckIn = new Date(parseData.guestRoomsCheckIn)
      }

      if (parseData.guestRoomsAlternativeCheckIn1) {
        parseData.guestRoomsAlternativeCheckIn1 = new Date(parseData.guestRoomsAlternativeCheckIn1)
      }

      if (parseData.guestRoomsAlternativeCheckIn2) {
        parseData.guestRoomsAlternativeCheckIn2 = new Date(parseData.guestRoomsAlternativeCheckIn2)
      }

      if (parseData.needRequestBy) {
        parseData.needRequestBy = new Date(parseData.needRequestBy)
      }

      Object.assign(formData, parseData)
    } catch (error) {
      console.error('DEBUG ERROR', error)
    }

    return formData
  }

  /** add data to textarea debug */
  function debugWatcher() {
    watchEffect(() => {
      debugVersionData.value = JSON.stringify(formData)
    })
  }

  return { debugReplace, debugVersionData, debugWatcher }
}
